import {
    DndContext,
    KeyboardSensor,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {restrictToWindowEdges} from "@dnd-kit/modifiers";

export function Dragger(props) {
    const mouseSensor = useSensor(MouseSensor);
    const touchSensor = useSensor(TouchSensor);
    const keyboardSensor = useSensor(KeyboardSensor);

    const sensors = useSensors(
        mouseSensor,
        touchSensor,
        keyboardSensor,
    );

    return (
        <DndContext sensors={sensors} modifiers={[restrictToWindowEdges]} onDragEnd={props.onDragEnd} onDragStart={props.onDragStart} >
            {props.children}
        </DndContext>
    )
}
